/* eslint-disable camelcase */

import { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { useRouter } from "next/router";
import PropTypes from "prop-types";

import { useUser } from "@hmn/coolinarika-web-core/hooks";

import { FormBlock } from "../FormBlock";
import styles from "./Contact.style";
import contactFields from "./FormData";

/*
    @note: This component is no longer used since it was decided that the contact page is to be used
    for reporting content instead of a drawer. If this is still true in a few months, this can be safely
    deleted.
*/

const cityCountryString = (city, country) => {
    if (city && country) {
        return `${city}, ${country}`;
    }

    return city || country || "";
};

const ContactStyled = styled.div((props) => ({ ...styles(props) }));

const Contact = ({
    // This shouldn't be the default and it should be sent from outside. But it's ok from now as we only use this componnt for this type
    reportType = "Prijava neprimjerenog sadržaja",
    ...rest
}) => {
    const { profile } = useUser();
    const [populatedFormElements, setPopulatedFormElements] = useState(null);
    const [formFields, setFormFields] = useState(null);

    const router = useRouter();

    const reportUrl = router?.asPath;

    useEffect(() => {
        const type = reportType || "Prijava neprimjerenog sadržaja";
        setPopulatedFormElements({
            ...populatedFormElements,
            report_type: type,
            name: profile?.display_name,
            email: profile?.account?.email,
            country: cityCountryString(
                profile?.extended_attributes?.city,
                profile?.extended_attributes?.country,
            ),
            contentUrl: reportUrl,
            message: reportUrl ? `Želim prijaviti sadržaj na ${reportUrl}` : "",
        });
    }, [profile, reportType, reportUrl]);

    useEffect(() => {
        if (populatedFormElements) {
            const generatedFormFields = contactFields?.map((fields) => ({
                columns: fields?.columns?.map((formEl) => ({
                    ...formEl,
                    value: populatedFormElements[formEl.id],
                })),
            }));
            setFormFields(generatedFormFields);
        }
    }, [populatedFormElements]);

    return (
        <ContactStyled {...rest}>
            <p>
                Želiš nam nešto reći? Sjajno! Ispuni potrebna polja i pošalji nam poruku! Ukoliko
                prijavljuješ neku grešku, daj nam što više detalja i točan opis koraka potrebnih da
                Coolinarika štucne, a mi ćemo se potruditi da ti pomognemo čim prije. Koristan
                savjet - prijave tipa &quot;Ne otvara mi recept&quot; bez ikakvih drugih podataka
                isto uzimamo u obzir, no vjerojatno ćemo teško pomoći. Daj nam što više pojedinosti!
            </p>

            <FormBlock fields={formFields} inDrawer />
        </ContactStyled>
    );
};

Contact.propTypes = {
    reportType: PropTypes.string,
};

Contact.defaultProps = {
    reportType: undefined,
};

export default Contact;
